import { StubPage } from '../StubPage'
export function EmailsDocs() {
  return <StubPage title="Emails" summary="The Emails list shows all messages captured from your monitored mailboxes — subject, sender, received date, and attachment count. Clicking an email shows the full body and a list of attachments stored in the Storage Service." />
}
